// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__8jRFy","title":"styles_title__aVnmE","text":"styles_text__IRZeZ","participateContainer":"styles_participateContainer__5g5Wy"};